module.exports = __webpack_public_path__ + "img/partly-cloudy-day.cc7c42e9.svg";